import React from "react";
import ResetPasswordStep from "./routes/ResetPasswordStep";
import { Message } from "semantic-ui-react";
import { routes } from "utilities/routing/generatedRoutes";
import AuthPanel from "./routes/components/AuthPanel";
import { loginPage, needHelp } from "./routes/components/links";

const ResetPasswordApp = () => {
  const [error, setError] = React.useState<string>("");
  const [username, setUsername] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [step, setStep] = React.useState<server.dto.ResetMyPasswordSteps>("username");
  const [secretQuestion, setSecretQuestion] = React.useState<string>("");
  const [secretAnswer, setSecretAnswer] = React.useState<string>("");
  const [successMessage, setSuccessMessage] = React.useState<string>("");

  const onSubmit = async () => {
    setIsLoading(true);
    const response = await window.CoreApi.Account.ResetMyPassword({ username, secretAnswer });
    if (response.data.hasErrors) {
      setError(response.data.errors[0].message);
    } else {
      setError("");
    }
    setStep(response.data.data.step);
    setSecretQuestion(response.data.data.secretQuestion);
    setSuccessMessage(response.data.data.successMessage);
    setIsLoading(false);
  };

  return <AuthPanel additionalFooterContent={<>{loginPage}|{needHelp}</>}>
    {step === "username" && (<ResetPasswordStep
      title="Reset password"
      buttonText="Next Step"
      isLoading={isLoading}
      onSubmit={onSubmit}
      errorMessage={error}
    >
      <div className="margin-bottom-larger">
        <input
          onChange={e => { setUsername(e.target.value); }}
          type="text"
          placeholder="Username"
          name="username"
          autoComplete="username"
          autoCapitalize="none"
        />
      </div>
    </ResetPasswordStep>)}
    {step === "secretQuestion" && (<ResetPasswordStep
      title="Reset password"
      subTitle={secretQuestion}
      buttonText="Next Step"
      isLoading={isLoading}
      onSubmit={onSubmit}
      errorMessage={error}
    >
      <div className="margin-bottom-larger">
        <input
          onChange={e => { setSecretAnswer(e.target.value); }}
          type="text"
          name="secretQuestion"
          autoCapitalize="none"
        />
      </div>
    </ResetPasswordStep>)}
    {step === "passwordHasBeenReset" && (<ResetPasswordStep
      title="Reset password"
      buttonText="Login"
      isLoading={isLoading}
      onSubmit={() => window.location.href = routes.account_SignIn().absolute}
      errorMessage={error}
    >
      <div className="margin-bottom-larger">
        <Message color="green">
          <span dangerouslySetInnerHTML={{ __html: successMessage }}></span>
        </Message>
      </div>
    </ResetPasswordStep>)}
  </AuthPanel>;
};

export default ResetPasswordApp;
